import { withDataVersion } from '@hakimo-ui/hakimo/util';
import {
  AlarmMediaResponse,
  DataVersion,
  GetAlarmsMediaPayload,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useAlarmsMedia(
  onSuccess?: (
    data: AlarmMediaResponse[],
    variables?: GetAlarmsMediaPayload
  ) => void,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/alarm/media`;

  const request = new Request(url, {
    method: 'POST',
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<AlarmMediaResponse[], GetAlarmsMediaPayload>(
    request,
    {
      onSuccessInvalidationKeys: [],
      onSuccess,
      responseModifier: async (response) => {
        const respJson = await response.json();
        return respJson.payload;
      },
    }
  );
}

export default useAlarmsMedia;
